import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../services/api";

export default function LoginPage() {
  const navigate = useNavigate();
  const [mode, setMode] = useState("login"); // login | register
  const [form, setForm] = useState({ username: "", password: "", full_name: "", school: "", register_code: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (mode === "login") {
        const { data } = await authAPI.login(form.username, form.password);
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("teacher", JSON.stringify(data.teacher));
        navigate("/");
      } else {
        await authAPI.register(form);
        setMode("login");
        setError("");
        alert("회원가입 완료! 로그인해주세요.");
      }
    } catch (err) {
      setError(err.response?.data?.detail || "오류가 발생했습니다");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h2>생활기록부 자동화</h2>
        <p className="subtitle">교사 전용 시스템</p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>아이디</label>
            <input className="form-control" name="username" value={form.username} onChange={handleChange} required autoFocus />
          </div>
          <div className="form-group">
            <label>비밀번호</label>
            <input className="form-control" type="password" name="password" value={form.password} onChange={handleChange} required />
          </div>
          {mode === "register" && (
            <>
              <div className="form-group">
                <label>이름</label>
                <input className="form-control" name="full_name" value={form.full_name} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>학교명</label>
                <input className="form-control" name="school" value={form.school} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>가입 코드</label>
                <input className="form-control" name="register_code" value={form.register_code} onChange={handleChange} placeholder="관리자로부터 받은 가입 코드 입력" required />
              </div>
            </>
          )}
          <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: "100%", marginTop: 8 }}>
            {loading ? <><span className="spinner" />{mode === "login" ? "로그인 중..." : "가입 중..."}</> : mode === "login" ? "로그인" : "회원가입"}
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: 18, fontSize: ".87rem", color: "#6b7280" }}>
          {mode === "login"
            ? <span>계정이 없으신가요? <button className="btn btn-outline" style={{ padding: "3px 10px", fontSize: ".87rem" }} onClick={() => setMode("register")}>회원가입</button></span>
            : <span><button className="btn btn-outline" style={{ padding: "3px 10px", fontSize: ".87rem" }} onClick={() => setMode("login")}>로그인으로 돌아가기</button></span>
          }
        </div>
      </div>
    </div>
  );
}
